/* eslint-disable camelcase */
/* eslint-disable react/display-name */
/**
 * @file MissedAppointmentsByStageView.jsx
 * @author Fernando Ruano
 * @description Stage Indicator View Page
 */

// Dependencies
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router';

import styleGuideColors from 'commons/styleGuideColors';

// Components
import DashboardCard from 'components/DashboardCard';
import DashboardBar from 'components/Charts/DashboardBar';
/**
 * MissedAppointmentsByStage View
 * @param { Object } dashboardStaffActions - DashboardStaff Actions.
 * @return { Node } React node.
 */

function MissedAppointmentsByStageView({ dashboardStaffActions, clinicId }) {
  const { t: translate } = useTranslation();
  const history = useHistory();
  const [barsData, setBarsData] = useState(null);

  const { getMissedAppointmentsByStage } = dashboardStaffActions;

  const onGetData = (_, resp) => {
    if (resp?.data) {
      const labels = resp?.data?.map((itm) => itm.estadio);
      const data = resp?.data?.map((itm) => itm.cantidad);
      const datasets = [
        {
          data,
          backgroundColor: styleGuideColors.baxterBrandOrange
        }
      ];
      const dataObject = {
        labels,
        datasets
      };
      setBarsData(dataObject);
    } else {
      setBarsData([]);
    }
  };

  useEffect(() => {
    setBarsData(null);
    getMissedAppointmentsByStage({ clinicId }, onGetData);
  }, [clinicId, translate]);

  const handleDetailClick = (index) => {
    const stage = barsData.labels[index];
    const totalItems = barsData.datasets[0].data[index];
    history.push(
      `/main/dashboard-detail/missed-appointments-by-stage/${stage}/${totalItems}`
    );
  };
  return (
    <DashboardCard id="F7" loading={!barsData}>
      <DashboardBar
        title={translate('pageHeader.missedAppointments')}
        yTitle={translate('dashboardStaff.patientsNumber')}
        xTitle={translate('dashboard.stage')}
        displayLabels={false}
        dataValues={barsData}
        onDetailClick={handleDetailClick}
      />
    </DashboardCard>
  );
}

/**
 * Component definition of proptypes.
 */
MissedAppointmentsByStageView.propTypes = {
  dashboardStaffActions: PropTypes.shape({
    getMissedAppointmentsByStage: PropTypes.func.isRequired
  }),
  clinicId: PropTypes.any
};

export default MissedAppointmentsByStageView;
